module.exports = __webpack_public_path__ + "img/6.c8973b75.png";